import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LandingComponent, LandingUmComponent, LandingEssaComponent, LandingCensComponent } from '../pages/index.paginas';

const appRoutes: Routes = [
	{path: '', component: LandingComponent},
	{path: 'datalabUM', component: LandingUmComponent},
	{path: 'essa', component: LandingEssaComponent},
	{path: 'cens', component: LandingCensComponent},
];


export const appRoutingProviders: any[] = [];
export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);
